import { buildTestId, ComponentTestIds } from "../../helpers/testIdHelper";

export enum MetaItemsGroupsDirection {
  Horizontal = "horizontal",
  Vertical = "vertical",
}

export interface LabelMetaItemTestIds extends ComponentTestIds {
  /**
   * The label of meta item
   */
  label: string,
  /**
   * The value of the meta item
   */
  value: string,
}

export const buildLabelMetaItemTestIds = (baseTestId?: string) : LabelMetaItemTestIds => ({
  component: buildTestId(baseTestId),
  label: buildTestId(baseTestId, "-label"),
  value: buildTestId(baseTestId, "-value"),
});
